var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientWaveB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 690.687,
    y1: 7.91222,
    x2: -140.896,
    y2: -123.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe121"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-91.6826 -208.337C114.844 -436.539 637.337 -246.511 675.041 -22.4675C718.806 237.603 365.748 273.766 233.821 213.958C110.204 157.921 108.34 288.158 -47.6604 305.314C-195.16 282.916 -200.213 -88.4165 -91.6826 -208.337Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientWaveB);
export default __webpack_public_path__ + "static/media/gradient-wave-b.b7d8c6328ca8b68be5907eafb281f094.svg";
export { ForwardRef as ReactComponent };